import { render, staticRenderFns } from "./mis-ayudantes.vue?vue&type=template&id=5c48bfb0&"
import script from "./mis-ayudantes.component.ts?vue&type=script&lang=ts&"
export * from "./mis-ayudantes.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports